import { graphql, useStaticQuery } from 'gatsby'

const useNewsArchiveLink = (): string => {
	const data = useStaticQuery(graphql`
		query NewsArchiveLink {
			wpPage(isPostsPage: { eq: true }) {
				link
			}
		}
	`)

	return data.wpPage.link
}

export default useNewsArchiveLink
